import React from 'react';
import PropTypes from 'prop-types';
import {Typography, Stack, Card, CardContent} from 'views/components';
import {CheckCircle, Close, Edit} from 'views/icons';

const SummaryCard = (props) => {
  const {
    title,
    isValid,
    invalidMessage,
    onCardClick,
    children,
  } = props;

  const handleClick = () => {
    if (onCardClick) {
      onCardClick();
    }
  };

  return (
    <Card
      sx={{
        'border': '1px solid #E0E0E0',
        'cursor': 'pointer',
        'transition': 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: 'action.hover',
          borderColor: 'primary.main',
          transform: 'translateY(-2px)',
          boxShadow: 2,
        },
      }}
      onClick={handleClick}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{mb: 2}}>
          <Stack direction="row" alignItems="center" spacing={2}>
            { isValid ? <CheckCircle color="success" /> : <Close color="error" /> }
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
          </Stack>
          <Edit sx={{color: 'text.secondary', fontSize: 20}} />
        </Stack>
        {
          isValid ?
            (children) :
            (
              <Typography variant="body2" color="text.secondary">
                {invalidMessage}
              </Typography>
            )
        }
      </CardContent>
    </Card>
  );
};

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  invalidMessage: PropTypes.string,
  onCardClick: PropTypes.func,
  children: PropTypes.node,
};

export default React.memo(SummaryCard);
